import React, { useState } from 'react'
import axios from 'axios'
import { env as environment } from "../controllers/environment";

import { RotatingLines } from "react-loader-spinner";




// ...existing code...
import VerificationTable from './VerificationTable';

const SubmissionStatus = () => {
  const [value, setvalue] = useState("")
  const [spinner, setspinner] = useState(false)
  const [spinner1, setspinner1] = useState(false)
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [wrongCreds, setWrongCreds] = useState(false)
  const [bypassWarning, setBypassWarning] = useState("")
  // const [emptyValue, setEmptyValue] = useState(false)
  const [noData, setNoData] = useState(false)
  const [userData, setUserData] = useState([]);
  const [activeSubmission, setActiveSubmission] = useState([]);
  const [archivedSubmission, setArchivedSubmission] = useState([]);

  const getdata = async () => {
    console.log("getdata called")
    setspinner1(true);
    setActiveSubmission([])
    setArchivedSubmission([])
    if (value === "") {
      console.log("NO data entered")
      // setEmptyValue(true)
      setspinner1(false)
    } else {

      const json = { searchField: value, apikey: environment.apikey };
      await axios.post(environment.getSubmissionDetails, json)
        .then((res) => {
          console.log("apiREs", res.data.data)
          // console.log("getSubmissionDetails RES::>", res.data.data[0])


          if (res?.data?.msg == "No data found") {
            console.log("not found")
            setUserData([])
            setNoData(true);
            setTimeout(() => {
              setNoData(false)
            }, 5000);
          }
          if (res.data.data) {
            setArchivedSubmission([])
            setUserData(res.data.data)
            for (const item of res.data.data) {
              console.log("element:::", item)
              if (item.type === "cbreArchive") {
                console.log("Archived submission:", item)
                setArchivedSubmission(archivedSubmission => [...archivedSubmission, item])
              } else {
                setActiveSubmission(activeSubmission => [...activeSubmission, item])
              }
            }
          }

          console.log("userdata11", userData[0]?.status?.utility_verify)
          console.log("userdata", userData)

        })
    }
    setspinner1(false)
  }



  const handleLogin = () => {
    // auth(username, password)
    if (username === "AdminCBRE" && password === "1FgBj@C7u!EA6") { setIsAuthenticated(true) }
    else {
      setWrongCreds(true);
      setTimeout(() => {
        setWrongCreds(false);
      }, 5000);
    }
  }





  const bypassWarningModal = async (type) => {
    setBypassWarning(type)
  }
  const closeBypassWarningModal = async () => {
    setBypassWarning("")
  }

  const bypassSubmission = async (category) => {
    // console.log("bypassCategory", category)
    setspinner(true)
    console.log("bypassSubmission")
    const json = { email: userData[0]?.email, category: category, apikey: environment.apikey };
    await axios.post(environment.bypassSubmission, json)
      .then((res) => {
        console.log("bypassSubmissionRES", res.data)
        getdata();
      }).catch((err) => {
        console.error(err)
      });
    setspinner(false)
    setBypassWarning("")
  }


  // ...existing code...



  return (
    <div >
      {/* <Header /> */}
      <div className="newpage">

        {isAuthenticated === false ?

          <div className='login-container'>
            <div className='login-box'>
              <input className='login-input' value={username}
                onChange={(e) => setUsername(e.target.value)} type='input' name="username" placeholder='Username'></input>
              <input className='login-input' value={password}
                onChange={(e) => setPassword(e.target.value)} type='password' name="password" placeholder='Password'></input>
              <button className='login-button' onClick={() => handleLogin()}>Login</button>
              {wrongCreds && <p className='wrong-login-creds'>Invalid username or password!</p>}
            </div>

          </div>

          :
          <>
            {/* <form>  */}
            {bypassWarning !== "" &&
              <div className="bg-blur-modal">
                <div className="modal-container">
                  {/* <p> */}
                  Document submission will be bypassed.<br></br> Are you sure you want to continue?
                  {/* </p> */}
                  <div className="bypass-btns-container">
                    <button className="resubmit-btn-2" onClick={() => bypassSubmission(bypassWarning)}>

                      {spinner ? <RotatingLines strokeColor="white" strokeWidth="4" animationDuration="0.75" width="25" visible={true} /> : " Yes, continue "}
                    </button>
                    <button className="resubmit-btn-2" onClick={() => closeBypassWarningModal()}>
                      No
                    </button>

                  </div>
                </div>
              </div>}
            <div className='status-header'>
              <div className='input-form home-input' >
                <input
                  className="input-box"
                  type="text"
                  value={value}
                  onChange={(e) => setvalue(e.target.value)}
                  placeholder="Enter submission id or email"
                />
                <button type="submit" className='input-btn' onClick={getdata}>
                  {spinner1 ? <RotatingLines strokeColor="white" strokeWidth="4" animationDuration="0.75" width="18" visible={true} /> : " Go "}
                </button>
              </div>
              {
                noData && <div className='no-data-msg'>No data found!</div>
              }

              {userData[0]?.email && <div className='submission-id-text'> Email: {userData[0]?.email} </div>}
            </div>
            {/* </form> */}

            {/* =====================table    */}

            {
              activeSubmission.length > 0 &&
              <>
                {
                  activeSubmission?.map((element, index) => (
                    <div key={element.unique_submissionID || `active-${index}`}>
                      {(element?.status?.utility_verify === "completed" || element.status?.bank_verify === "completed") ? (
                        <div className='table-wrapper' key={element.unique_submissionID || `active-${index}`}>
                          <div className='active-data-heading'>
                            <div className='submission-id-text'>Submission Id: {element?.unique_submissionID}</div>
                          </div>
                          <span className='table-header'>
                            Address verification details
                            {(element.status?.utility_bad_doc === true || element.status?.utility_verify === false) && element.status?.bank_verify_callback === true && (
                              <button className='generate-submission-id' onClick={() => bypassWarningModal("utility_verify")}>{spinner ? <RotatingLines strokeColor="black" strokeWidth="4" animationDuration="0.75" width="25" visible={true} /> : " Bypass submission "}</button>
                            )}
                          </span>
                          <VerificationTable status={element.status} type="utility" />
                          <span className='table-header'>
                            Bank verification details
                            {element.status?.bank_verify === false && element.status?.utility_verify_callback === true && (
                              <button className='generate-submission-id' onClick={() => bypassWarningModal("bank_verify")}>{spinner ? <RotatingLines strokeColor="black" strokeWidth="4" animationDuration="0.75" width="25" visible={true} /> : " Bypass submission "}</button>
                            )}
                          </span>
                          <VerificationTable status={element.status} type="bank" />
                        </div>
                      ) : "No documents submitted!"}
                    </div>
                  ))
                }
              </>

            }


            {archivedSubmission.length > 0 &&
              <>
                {
                  archivedSubmission?.map((element, index) => (
                    <div key={element.unique_submissionID || `archived-${index}`}>
                      {(element?.status?.utility_verify === "completed" || element.status?.bank_verify === "completed") && (
                        <div className='table-wrapper' key={element.unique_submissionID || `archived-${index}`}>
                          <div className='archived-data-heading'>
                            <h5>Archived Data </h5>
                            <div className='submission-id-text'>Submission Id: {element?.unique_submissionID}</div>
                          </div>
                          <span className='table-header'>Address verification details</span>
                          <VerificationTable status={element.status} type="utility" />
                          <span className='table-header'>Bank verification details</span>
                          <VerificationTable status={element.status} type="bank" />
                        </div>
                      )}
                    </div>
                  ))
                }
              </>


            }

          </>

        }
      </div>

    </div >
  )
}

export default SubmissionStatus;
